import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { GtmService } from './analytics/gtm.service';

@Injectable()
export class DuplicateRequestInterceptor implements HttpInterceptor {
    constructor(private gtmService: GtmService) {}

    private activeRequests = new Map<string, Subject<HttpEvent<any>>>();

    // Requests that should return the same observable
    private allowObservableReuseRequest = [{ method: 'GET', urlContains: 'customer/bottom_strip_details' }];

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const requestKey = this.generateRequestKey(request);

        if (this.activeRequests.has(requestKey)) {
            const shouldReuseObservable = this.shouldReuseObservable(request);
            if (!shouldReuseObservable) {
                this.gtmService.logWebAnalyticsEvent(
                    'Duplicate request detected',
                    `Method: ${request.method}, Url: ${request.urlWithParams}`
                );
            } else {
                return this.activeRequests.get(requestKey).asObservable();
            }
        }

        const subject = new Subject<HttpEvent<any>>();
        this.activeRequests.set(requestKey, subject);

        next.handle(request)
            .pipe(finalize(() => this.activeRequests.delete(requestKey)))
            .subscribe({
                next: event => subject.next(event),
                error: err => subject.error(err),
                complete: () => subject.complete()
            });

        return subject.asObservable();
    }

    private generateRequestKey(request: HttpRequest<any>): string {
        const url = request.urlWithParams;
        const body = request.body ? JSON.stringify(request.body) : '';
        return `${request.method}:${url}|${body}`;
    }

    private shouldReuseObservable(currentReq: HttpRequest<any>): boolean {
        return this.allowObservableReuseRequest.some(
            request => currentReq.method === request.method && currentReq.url.includes(request.urlContains)
        );
    }
}
